var React = require('react');

function Check9x7 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.002,1.396 L3.461,7.002 L-0.002,3.498 L1.383,2.096 L3.461,4.199 L7.617,-0.006 L9.002,1.396 Z"}));
}

Check9x7.defaultProps = {"width":"9px","height":"7px"};

module.exports = Check9x7;

Check9x7.default = Check9x7;
